import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
export default {
  name: "AdminProducersSubMenusLinks",
  props: {
    loggedUserData: {
      type: Object,
      required: true
    },
    forceTab: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      selectedTab: "wines",
      tabs: {
        wines: "wines",
        spirits: "spirits"
      }
    };
  },
  watch: {
    $route: function $route(oldRoute, newRoute) {
      var _oldRoute$query, _newRoute$query;
      if (((_oldRoute$query = oldRoute.query) === null || _oldRoute$query === void 0 ? void 0 : _oldRoute$query.tab) !== ((_newRoute$query = newRoute.query) === null || _newRoute$query === void 0 ? void 0 : _newRoute$query.tab)) {
        this.changeTab();
      }
    }
  },
  created: function created() {
    var _this$$route$query;
    this.selectedTab = this.forceTab || ((_this$$route$query = this.$route.query) === null || _this$$route$query === void 0 ? void 0 : _this$$route$query.tab) || this.tabs.wines;
  },
  methods: {
    changeTab: function changeTab() {
      var _this = this;
      var initTab = this.selectedTab;
      if (this.$route.query.tab) {
        this.selectedTab = this.tabs[this.$route.query.tab];
      } else if (this.selectedTab) {
        this.selectedTab = this.tabs[this.selectedTab];
      }
      if (!this.selectedTab || !Object.values(this.tabs).some(function (x) {
        return x == _this.selectedTab;
      })) {
        this.selectedTab = this.tabs.wines;
      }
      if (this.forceTab) {
        this.selectedTab = this.forceTab;
      }
      if (this.selectedTab !== initTab) {
        this.$emit("tabChanged", this.selectedTab);
      }
    }
  }
};